export const decodeJwtToken = (t: string) => {
  try {
    return JSON.parse(
      atob(t.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')),
    );
  } catch (e) {
    throw new Error(`Error decoding JWT: ${e}`);
  }
};
